import PassRateDetailsDateRangeFilter from "../../../components/PassRateReport/PassRateDetails/PassRateDetailsDateRangeFilter"
import DateRangeReportGrid from "../../../components/PassRateReport/PassRateDetails/PassRateReportDateRange"
import {useAppDispatch} from "../../../store"
import { useEffect } from "react"
import { getUserDealersAction } from "../../App/appSlice"
import Breadcrumb from "../../../shared/CustomBreadcrumb"
import { Card } from "@volvo/vcdk-react/Card";
import { CardContent } from "@volvo/vcdk-react/CardContent";
import { Typography } from "@volvo/vcdk-react/Typography";

const styleCardContent={"--vcdk-spacing-8":".4rem"}  as React.CSSProperties
const PassRateDetails = () => {
    const dispatch = useAppDispatch()
    useEffect(() => {
        dispatch(getUserDealersAction("MULTIPLE_DEALER"))
    }, [dispatch])
    return (
        <>
            <Breadcrumb crumbs={['Manage MOT', 'Pass Rates Details']} />
            <PassRateDetailsDateRangeFilter />
            <div className="row">
                <div className="col-md-12">
                    <Card>
                        <CardContent style={styleCardContent}>
                            <Typography variant="subtitle2" className="text-muted" style={{marginBottom:".4rem"}}>Monthly Pass Rates</Typography>
                            <DateRangeReportGrid />
                        </CardContent>
                    </Card>
                </div>
            </div>
        </>
    )
}

export default PassRateDetails
